import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ELEVATION } from '@openx/components-core/lib/theme/elevation';

export type GatheredMetricsColumn = {
  dataTest: string;
  title: string;
  elements: { dataTest: string; title: string; value: string }[];
};

type GatheredMetricsProps = {
  columns: GatheredMetricsColumn[];
};

export const GatheredMetrics = ({ columns }: GatheredMetricsProps) => {
  return (
    <Card
      elevation={0}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '4px',
        boxShadow: ELEVATION.elevation0,
        height: '296px',
        flex: 2,
      }}
    >
      <CardContent sx={{ p: 1.5 }}>
        <Stack
          direction="row"
          sx={{
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          {columns.map(column => (
            <Stack
              key={column.dataTest}
              data-test={column.dataTest}
              direction="column"
              sx={{
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: 2,
                flex: 1,
              }}
            >
              <Typography variant="body1Bold">{column.title}</Typography>

              {column.elements.map(element => (
                <Stack
                  key={element.dataTest}
                  data-test={element.dataTest}
                  direction="column"
                  sx={{
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                  }}
                >
                  <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                    {element.title}
                  </Typography>

                  <Typography variant="h2">{element.value}</Typography>
                </Stack>
              ))}
            </Stack>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};
